module.exports = __webpack_public_path__ + "static/img/no-control.a396c556.png";